import axios from 'axios';
import { getApiRoot } from '@/lib/domainResolver';

/**
 * The platform console's API client — deliberately NOT useAppApi: it must never send the
 * tenant `X-Company-Id` header or ride the tenant JWT, and it attaches the per-session CSRF
 * token the server hands out at sign-in and on /me (routes/platformRouter.js).
 *
 * The CSRF token is kept in module memory only — never localStorage — so it dies with the
 * tab, the same lifetime as the console's in-memory state.
 */
let csrfToken = null;

export function setCsrfToken(token) {
  csrfToken = token || null;
}

const client = axios.create({ baseURL: `${getApiRoot()}/api/platform`, withCredentials: true });
client.interceptors.request.use((config) => {
  if (csrfToken && config.method && config.method.toLowerCase() !== 'get') config.headers['x-csrf-token'] = csrfToken;
  return config;
});

export function errorOf(ex) {
  const data = ex && ex.response && ex.response.data;
  return { message: (data && data.error) || (ex && ex.message) || 'Request failed', code: data && data.code, status: ex && ex.response && ex.response.status };
}

export async function platformGet(path, params) {
  return (await client.get(path, { params })).data;
}

export async function platformSend(method, path, body) {
  return (await client.request({ method, url: path, data: body })).data;
}
